/**
 * @description This function returns a string representing the pricing band for a given number of registrations, based on the provided price value and predefined pricing bands.
 * It uses the `find` method to locate the first pricing band that matches the criteria of having a minimum price less than or equal to the provided price and a maximum price greater than or equal to the provided price. If a matching pricing band is found, its name is returned; otherwise, 'Unknown' is returned.
 * @param {number} price - The price value for which the pricing band is to be determined.
 * @returns { '0 - 99.99' | '100 - 249.99' | '250 - 499.99' | '500 - 749.99' | '750 - 999.99' | '1,000 - 1,999.99' | `2,000.00 - 4,999.99' | '5,000 - 9,999.99' | `10,000+` } - The name of the pricing band that corresponds to the provided price, or 'Unknown' if no matching band is found.
 */

import { pricingBands } from '../../const/pricingBands';

export function getPricingBand(price: number) {
  const roundedPrice = Math.round(price * 100) / 100; // Round to 2 decimal places
  const band = pricingBands.find((band) => roundedPrice >= band.min && roundedPrice <= band.max);
  return band ? band.name : 'Unknown';
}
